'use client'; // if you're using Next.js with SSR

import React, { JSX } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import type { WorkflowRegistryFields } from '../Sidebar/sidebarPalette';
import './CommonNode.css';

export type NodeData = {
  label: string;
  icon: string;// React.ReactElement; // NOT string
  onOpenModal: (id: string) => void;
  type?: string;
  settings?: Record<string, any>;
} & WorkflowRegistryFields;

const CommonNode = ({ id, data }: NodeProps<NodeData>) => {
  return (
    <div
      className="common-node"
      onClick={(e) => {
        e.stopPropagation();
        data.onOpenModal(id);
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        id="input"
        className="custom-handle-left"
        style={{ marginLeft: '5px' }}
      />

      <div className="common-node-content">
      {/* {data.icon} */}
        <div className="node-label" style={{ fontSize: '7px' }}>
          {data.label?.replace(/node/gi, '').trim()}
        </div> 
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="output"
        className="custom-handle-right"
      />
    </div>
  );
};

export default CommonNode;
